var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback } from 'react';
import { TextButton } from '@hn-ui/buttons';
import { styled } from 'styled-components';
import { useGoogleAnalytics } from '@happynumbers/front-utils';
import PackRow from './PackRow';
import { gaTrackerIds } from '../../../pages/utils';
var LoadMoreButton = styled(TextButton).withConfig({ displayName: "LoadMoreButton", componentId: "sc-csieup" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 24px;\n"], ["\n  margin-top: 24px;\n"])));
var DomainWrapper = styled.div.withConfig({ displayName: "DomainWrapper", componentId: "sc-q5hyj" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n\n  &:not(:last-child) {\n    margin-bottom: ", ";\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n\n  &:not(:last-child) {\n    margin-bottom: ", ";\n  }\n"])), function (_a) {
    var hasLoadMoreButton = _a.hasLoadMoreButton;
    return hasLoadMoreButton ? '32px' : '64px';
});
var PackWrapper = styled.div.withConfig({ displayName: "PackWrapper", componentId: "sc-12k2xec" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: left;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: left;\n  width: 100%;\n"])));
var Title = styled.h3.withConfig({ displayName: "Title", componentId: "sc-1ortpyu" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 32px;\n  margin: 0 0 16px;\n  width: 100%;\n  color: ", ";\n"], ["\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 32px;\n  margin: 0 0 16px;\n  width: 100%;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black50;
});
var Domain = function (_a) {
    var _b = _a.data, domain = _b.domain, printables = _b.printables, handleOnPackTagClick = _a.onPackTagClick, lockReason = _a.lockReason, rest = __rest(_a, ["data", "onPackTagClick", "lockReason"]);
    var _c = useState(false), isLoadMoreWasClick = _c[0], setIsLoadMoreWasClick = _c[1];
    var currentPrintables = isLoadMoreWasClick ? printables : [printables[0]];
    var hasDomain = Boolean(domain);
    var isNeedShowLoadMoreButton = printables.length > 1 && currentPrintables.length === 1;
    var loadMoreButtonText = "Load more printables: " + ((printables.length - 2) * 3 + printables[printables.length - 1].length);
    var ga4 = useGoogleAnalytics(gaTrackerIds);
    var handleOnLoadMoreClick = useCallback(function () {
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsTeacher('click_load_more_printables', {
            category: 'Printables',
        });
        setIsLoadMoreWasClick(true);
    }, [ga4]);
    return (_jsxs(DomainWrapper, __assign({ "data-testid": 'domain', hasLoadMoreButton: isNeedShowLoadMoreButton }, rest, { children: [hasDomain && _jsx(Title, { children: domain }, void 0), _jsx(PackWrapper, { children: currentPrintables.map(function (printable) { return (_jsx(PackRow, { data: printable, onPackTagClick: handleOnPackTagClick, lockReason: lockReason }, printable[0].id)); }) }, void 0), isNeedShowLoadMoreButton && (_jsx(LoadMoreButton, __assign({ size: 'medium', fit: true, onClick: handleOnLoadMoreClick, "data-testid": 'load-more-button' }, { children: loadMoreButtonText }), void 0))] }), void 0));
};
export default Domain;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
